import { Link } from 'react-router-dom';
import { pageMeta } from '../../constants/pageMeta';
import { COMPANY_NAME, SITE_DOMAIN, SITE_NAME } from '../../constants/site';
import PolicyPage, { ContactBlock, List, Section } from '../components/PolicyPage';

const META = pageMeta(
  'About Us',
  `${SITE_NAME} is an independent travel agency run by ${COMPANY_NAME}. Learn who we are, what we do and how we work.`,
  '/about-us'
);

export default function AboutPage() {
  return (
    <PolicyPage
      title="About Us"
      meta={META}
      showUpdated={false}
      intro={`${SITE_NAME} is an independent travel agency run by ${COMPANY_NAME}. We help people plan and book trips — and we stay with them until they are home.`}
    >
      <Section title="Who we are">
        <p>
          {SITE_NAME} ({SITE_DOMAIN}) is a trade name of {COMPANY_NAME}, a company registered in Wyoming, United States.
          {COMPANY_NAME} is an independent travel advisory company affiliated with Fora Travel. Our team of travel
          advisors helps customers with flights, hotels, rental cars, cruises, vacation packages and group travel.
        </p>
        <p>
          We are <strong>not</strong> an airline, hotel, car rental company or cruise line, and we are not affiliated
          with, endorsed by or acting on behalf of any of them. When you book with us, we arrange your travel with the
          provider on your behalf as your travel agent.
        </p>
      </Section>

      <Section title="What we do">
        <List
          items={[
            'Listen to what you need — destination, dates, budget and anything that matters to you.',
            'Compare options from travel providers and explain the differences in routes, rules and price.',
            'Send you an itemised quote showing the provider price, taxes and our service fee as separate lines.',
            'Book only after you approve the final total, then send you your confirmation and the provider’s reference.',
            'Help with questions, changes and cancellations after you book, within the provider’s rules.',
          ]}
        />
      </Section>

      <Section title="How we are paid">
        <p>
          We may earn a service fee that you pay us directly, and in some cases a commission that the travel provider
          pays us. Any service fee you pay is always shown to you and agreed before you are charged. Details are on our{' '}
          <Link to="/service-fees">Service Fees</Link> page and our{' '}
          <Link to="/advertiser-disclosure">Advertiser Disclosure</Link>.
        </p>
      </Section>

      <Section title="Our standards">
        <List
          items={[
            'Honest about who we are on every page, call and email.',
            'No hidden fees and no booking without your clear approval.',
            'Provider rules shared before you book, not after.',
            'Your personal information used only to serve you, and never sold.',
          ]}
        />
      </Section>

      <Section title="Company details">
        <ContactBlock />
        <p>
          Ready to start? <Link to="/#quote">Request a free quote</Link> or <Link to="/contact-us">contact us</Link>.
        </p>
      </Section>
    </PolicyPage>
  );
}
